module.exports = __webpack_public_path__ + "img/phone.1293282b.png";